module.exports = __webpack_public_path__ + "img/bd0f0ef341af1683382485672343dda2.svg";